export default "__VITE_ASSET__D5Z_tOWS__"